import React from 'react';
import { Box, ScopedCssBaseline } from '@mui/material';
import BillingRecordList from './BillingRecordList';

function TablePage(props) {
  return (
    <ScopedCssBaseline>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
        }}
      >
        <BillingRecordList />
      </Box>
    </ScopedCssBaseline>
  );
}

export default TablePage;
